import { useState } from 'react';
import { Exit } from '../../../ui/icons';
import { useTranslation } from 'react-i18next';

const Modal = ({ message, onClose, onConfirm, show }) => {
    const { t } = useTranslation();
    
    if (!show) return null; 

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" style={{
            zIndex: 9999
        }}>
            <div className="bg-white p-6 w-[340px]">
                <div className="flex justify-end items-center">
                    <button onClick={onClose} className="text-xl" aria-label={t('modal.close_button')}>
                        <Exit />
                    </button>
                </div>
                <img 
                    src="./images/Profile/delete.png" 
                    className='w-full' 
                    alt={t('modal.delete_image_alt')} 
                />
                <p className="text-center font-semibold py-4">
                    {message || t('modal.default_message')}
                </p>
                <div className="flex justify-between gap-2">
                    <button 
                        onClick={onClose} 
                        className="bg-[#402D1D] text-[#FFF] px-4 py-1 rounded-xl w-full"
                    >
                        {t('modal.no_button')}
                    </button>
                    <button 
                        onClick={onConfirm} 
                        className="bg-[#C6A982] text-[#FFF] px-4 py-1 w-full rounded-xl"
                    >
                        {t('modal.yes_button')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;